import styled from "@emotion/styled"

export const Button = styled.button`
  display:flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  color: ${ props => props.color ? props.color : 'none'};
  &:hover {
    color: ${props => props.hoverColor ? props.hoverColor : 'none'};
  }
  border: 0;
  margin: 0;
  background-color: transparent;
  pointer-events: all;

  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  padding: 0;
  position: relative; 
  > * {
    max-height: 32px;
  }

  &.frame {
    background: rgba(255, 255, 255, 0.5);
    &.revers {
      background: rgba(0, 0, 0, 0.5);
    }
    backdrop-filter: blur(5px);
    padding: 8px;
    &::after {
      content: '';
      display: block;
      position: absolute;

      box-sizing: border-box;

      left: 2px;
      right: 2px;
      top: 2px;
      bottom: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      flex: none;
      order: 1;
      flex-grow: 0;
      z-index: 1;
    }
    &.revers {
      background: rgba(0, 0, 0, 0.5);
      &::after {
        border: 1px solid rgba(255, 255, 255, 0.15);
      }
    }
  }
`
